var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-1 uploaded-image thumbnail has-background-primary-light"},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Asset"}}):_c('div',{staticClass:"is-flex align-items-center justify-center"},[_c('q-r-code-icon',{staticStyle:{"margin":"1px 0 0 1px"},attrs:{"color":"has-text-cool-blue-text","size":16}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }